/*
 * @Author: your name
 * @Date: 2022-03-04 15:07:25
 * @LastEditTime: 2022-03-04 16:09:18
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \Codes\2019\CQ\cq-vs-vote\src\utils\md5-sign.js
 */
import { newGuid } from "./utils";
import { secret } from "../config";
import "./md5.js";
/**
 * @description: 字符排序
 * @param {*} params key=value&key=value 格式字符串 最后加上
 * @param {*} noncestr 当前的随机字符串
 * @param {*} timestamp 时间戳
 * @param {*} method 方法
 * @return {*}
 */
export const urlSort = (params, noncestr, timestamp, method) => {
  let url = params
    .split("&")
    .sort()
    .join("&");
  // console.log(params, "加上密钥前");
  const tmp = url + `${secret}`;
  // console.log(tmp, "加上密钥后");
  //   然后进行md5加密生成签名
  const sign = tmp.MD5(32);
  if (method == "get") return `${url}&sign=${sign}`;
  else return `noncestr=${noncestr}&timestamp=${timestamp}&sign=${sign}`;
};
/**
 * @description: 将data转换成key=value&key=value 格式 并且排序
 * @param {*} data 对象
 * @return {*}
 */
export const urlKeyValue = (data, method) => {
  // 如果是put的话直接不用签名了
  let obj;
  if (method == "put")
    obj = {
      // 随机字符串
      noncestr: newGuid(),
      // 时间戳
      timestamp: Date.parse(new Date())
        .toString()
        .substring(0, 10)
    };
  else
    obj = {
      // 随机字符串
      noncestr: newGuid(),
      // 时间戳
      timestamp: Date.parse(new Date())
        .toString()
        .substring(0, 10),
      ...data
    };
  let params = "";
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const element = obj[key];
      params += `${key}=${element}&`;
    }
  }
  params = params.slice(0, -1);
  // console.log(params, "所有字符串");
  return urlSort(params, obj.noncestr, obj.timestamp, method);
};
